module.exports = __webpack_public_path__ + "static/media/NESPRE.fbfba3d2.svg";